import React from 'react';
import PropTypes from 'prop-types';

export const ModalTitle = ({ children }) => {
  return <div className="subscription-modal__title">{children}</div>;
};

ModalTitle.propTypes = {
  children: PropTypes.string.isRequired,
};
